import React, { Suspense, useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Container } from '@mui/material'
import CssBaseline from '@mui/material/CssBaseline'
import jwtDecode from 'jwt-decode'
import toLower from 'lodash/toLower'

import axios from '../api/axios'
import { Auth } from '../api/index'
import { REACT_APP_ENV, REACT_APP_VERSION } from '../common/constants'
import Alert from '../components/Alert'
import AppSpinner from '../components/AppSpinner'
import useAuth from '../hooks/useAuth'
import { checkEnvironment } from '../utils/helpers'
import { getLocalStorage } from '../utils/localStorage.utils'

function App() {
  const [isLoading, setIsLoading] = useState(true)
  const { setAuth } = useAuth()

  const { dealerId, url, refactory } =
    document.getElementById('root').dataset || {}

  const isDebuggerVisible =
    toLower(getLocalStorage('isDebuggerVisible')) === 'true'
  if (isDebuggerVisible) {
    // eslint-disable-next-line no-console
    console.log(`🚀 Env: ${REACT_APP_ENV}, Version: ${REACT_APP_VERSION}`)
  }

  useEffect(() => {
    if (checkEnvironment(REACT_APP_ENV, 'carexport')) {
      Auth.getToken(axios, url)
        .then((res) => {
          const accessToken = res?.data?.access_token
          const user = jwtDecode(accessToken)
          setIsLoading(false)
          setAuth({ user, dealerId, accessToken, refactory })
        })
        // eslint-disable-next-line no-console
        .catch((e) => console.error(e))
    } else {
      setIsLoading(false)
    }
  }, [dealerId, setAuth, url, refactory])

  return (
    <Suspense fallback={<AppSpinner />}>
      <CssBaseline />
      <Container
        maxWidth={false}
        disableGutters
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
        }}
      >
        <Alert />
        {isLoading ? <AppSpinner /> : <Outlet />}
      </Container>
    </Suspense>
  )
}

export default App
